import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=56397bfa&scoped=true&"
import script from "./groupList.vue?vue&type=script&lang=js&"
export * from "./groupList.vue?vue&type=script&lang=js&"
import style0 from "./groupList.vue?vue&type=style&index=0&id=56397bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56397bfa",
  null
  
)

export default component.exports